// extracted by mini-css-extract-plugin
module.exports = {"list":"SocialLinks-module--list--3DW0i","icon":"SocialLinks-module--icon--1cFtB"};